export default "__VITE_ASSET__DjGiBn_5__"